/**
 * Returns horizontal bar data converted to percentage.
 * (returns floating point numbers up to 2 decimals).
 *
 * @param data Data to be displayed
 * @returns number[][]
 */
export function dsHorizontalBarGetPercentageData(data: number[][]): number[][] {
  const formattedData: number[][] = [];
  const nbStacked = data[0].length;
  const total: number[] = [];

  for (let i = 0; i < nbStacked; i++) {
    let totalRow = 0;

    data.forEach((d) => {
      totalRow += d[i];
    });

    total.push(totalRow);
  }

  data.forEach((d) =>
    formattedData.push(
      d.map((nb, index) => {
        const percentage = (nb / total[index]) * 100;
        return +parseFloat(percentage.toString()).toFixed(2);
      })
    )
  );

  return formattedData;
}
